import { GridCellProps } from "@progress/kendo-react-grid";
import { useMemo } from "react";
import "./cell.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function ImageCell(props: GridCellProps) {
    const getImageURL = useMemo((): string => {
        let documents = props.dataItem.documents?.find((d: any) => d.role === 'image');
        return props.dataItem.approuve_web ? documents?.uriCdn : documents?.uriInterne
    }, [props.dataItem.approuve_web, props.dataItem.documents]);

    const handleOnError = (elem: any) => {
        let alt = document.createTextNode(elem.target.getAttribute('alt'));
        elem.target.parentNode.insertBefore(alt, elem.target);
        elem.target.parentNode.removeChild(elem.target);
    }

    return <td colSpan={1} className="k-table-td" role="gridcell" aria-colindex={1} aria-selected="false" data-grid-col-index="0"><LazyLoadImage src={getImageURL ? getImageURL : ""} alt="(aucunes)" className="image-cell" loading="lazy" onError={handleOnError} /></td>;
}